<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col-auto">
                Back Office Reports
            </div>
            <!-- <div class="col"></div>
            <div class="col-auto">
                <button (click)="navigateToCommonReport()" class="btn btn-primary btn-sm">Report</button>
            </div> -->
        </div>
    </div>
    <div class="card-body">
        <div *ngFor="let mainmenu of menus.SubMenus; let i = index">
            <span class="main-reportlabel">{{mainmenu.MenuLabel}}</span>
            <div class="row g-4 pt-2">
                @for (reports of mainmenu.SubMenus; track reports; let i = $index;) {
                    <div class="col-md-4 cursor-pointer" (click)="ReportPage(reports.ESS_MenuMasterId,reports.URL)">
                        <div class="tile m-1">
                            <div class="row" style="line-height: 30px;">
                                <div class="col-2 p-1 m-0 text-center" style="background-color: #EBF3FE;color: #0078D4;">
                                    <img src="../../../../assets/{{reports.Icon}}" style="height: 30px;">
                                </div>
                                <div class="col-8 p-0 m-0" style="background-color: #EBF3FE;color: #0078D4;font-weight: 600; align-content: center;font-size: 12px;">
                                    {{reports.MenuLabel}}
                                </div>
                                <div class="col-2 p-1 m-0 text-center" style="background-color: #EBF3FE;color: #0078D4;">
                                    <img src="../../../../assets/logout.png" style="height: 20px;">
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
